import { Component, ViewChild, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-roe-autocomplete',
  templateUrl: './roe-autocomplete.component.html',
  styleUrls: ['./roe-autocomplete.component.scss']
})
export class RoeAutocompleteComponent implements OnChanges {

  @ViewChild('searchTextField', { static: false }) searchTextField: any;
  @Output() placeSelected = new EventEmitter<any>();
  @Input() roeLabel: string;
  @Input() roeList: any;

  roeControl = new FormControl();
  roeOptions: any;
  environment = environment;
  autocomplete: any;

  get inputLabel() {
    return this.roeLabel ? this.roeLabel : '';
  }

  ngOnChanges() {
    this._initAutoComplete();
  }

  emitRoe(e) {
    this.roeControl.setValue(e.code);
    this.placeSelected.emit({ point: e, isValid: true });
  }

  private _filter = (value: string | any, list): string[] => {
    const isEntireObject = value instanceof Object;
    return list.filter((option) =>
      option.code
        .toLowerCase()
        .includes(
          !isEntireObject ? value.toLowerCase() : value.code.toLowerCase(),
        ),
    );
  };

  private _initAutoComplete() {
    if (this.roeList && this.roeList.length) {
      this.roeOptions = this.roeControl.valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value as string, this.roeList)),
      );
    }
  }

}
